export default __webpack_public_path__ + "static/media/arrowDown.5878a08d.svg";